import React from "react";
import PropTypes from "prop-types";
import { RiSparklingLine } from "react-icons/ri";
import styles from "./FeedbackButton.module.css";

/**
 * FeedbackButton - ModernUI header entry point that opens the feedback modal.
 * Sits in ModernHeader's .rightSection alongside ThemeToggle / UserProfileMenu.
 * Rendered as a pill (sparkle icon + "Feedback" label) rather than an icon-only
 * circular button so its purpose is discoverable at a glance.
 *
 * @param {Object} props
 * @param {function} props.onClick - Called when the button is activated.
 */
const FeedbackButton = ({ onClick }) => {
  const label = "Send feedback";

  return (
    <button
      type="button"
      className={styles.feedbackButton}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <RiSparklingLine className={styles.icon} aria-hidden="true" />
      <span className={styles.label}>Feedback</span>
    </button>
  );
};

FeedbackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default FeedbackButton;
